import { render, staticRenderFns } from "./TrainingPlanItemPrint.vue?vue&type=template&id=3d842c74&"
import script from "./TrainingPlanItemPrint.vue?vue&type=script&lang=ts&"
export * from "./TrainingPlanItemPrint.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports